<div
  class="dropdown-container"
  [class.opened]="dropdownOpened && !(isDisabled || disabled)"
>
  <!-- Selector -->
  <div
    (click)="toggleDropdownStatus()"
    class="selector"
    [title]="currentSelection ? currentSelection.name : ''"
    [class.error]="hasError"
    [class.loading]="loading"
    [class.disabled]="isDisabled || disabled"
    [class.placeholder]="!currentSelection"
  >
    {{ currentSelection ? currentSelection.name : placeholder }}
    <i *ngIf="!loading" class="fas fa-chevron-down"></i>
    <i *ngIf="loading" class="fas fa-spinner fa-spin"></i>
  </div>

  <!-- Search -->
  <div *ngIf="searchable" class="search">
    <input
      [formControl]="searchControl"
      type="text"
      [placeholder]="searchPlaceholder"
    />
  </div>

  <!-- Dropdown -->
  <ul *ngIf="!disabled" class="dropdown" [class.search]="searchable">
    <li
      *ngIf="allowCustomValue && searchControl.valid && !!searchControl.value"
      (click)="onCustomOptionSelected()"
    >
      Utilizar: <b>{{ searchControl.value }}</b>
    </li>

    <!-- Options -->
    <li
      *ngFor="let option of optionsAvailable"
      (click)="!loading && onOptionSelected(option)"
      [title]="option ? option.name : ''"
      [class.active]="
        currentSelection && currentSelection.value === option.value
      "
    >
      {{ option.name }}
    </li>
  </ul>
</div>
